import React, { useState } from 'react';
import mailFrame from '../assets/login email.png';
import lockFrame from '../assets/login password.png';
import eyeIcon from '../assets/eye vector icon.png';
import logo from '../assets/logo PNG Transparent/Logo-10.png';
import { Link, useNavigate } from 'react-router-dom';
import api from '../sever/Api';
import { toast } from 'react-toastify';
import esscoBg from '../assets/essco-bg.png';
import logo1 from '../assets/new-Logo.png';
import textlogo from '../assets/UnlockYourPotential.png';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            toast.error('Please enter your email address');
            return;
        }

        setIsLoading(true);
        try {
            const response = await api.post('/api/auth/forgot-password', { email });

            if (response.data.otp) {
                toast.success(`OTP: ${response.data.otp} (Development Mode)`);
                console.log('Development OTP:', response.data.otp);
            } else {
                toast.success('OTP sent to your email address');
            }

            // Store email in localStorage for OTP page
            localStorage.setItem('resetEmail', email);
            navigate('/otp');
        } catch (error) {
            console.error('Forgot password error:', error);
            const errorData = error.response?.data;
            let message = errorData?.message || 'Failed to send OTP. Please try again.';

            // Show suggestions if available
            if (errorData?.suggestions && errorData.suggestions.length > 0) {
                message += `\n\nSuggestions: ${errorData.suggestions.join(', ')}`;
            }

            toast.error(message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className=' min-h-screen bg-[linear-gradient(126.39deg,#F7F6FA_5.58%,#F5F4FC_27.79%,#F2F2FE_48.29%,#F5F4FF_69.65%,#FFF9FF_94.42%)]' style={{
                backgroundImage: `url(${esscoBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className="flex flex-row justify-center items-center px-[32px] py-[16px] bg-[rgba(247,248,250,0.01)] shadow-[0px_2px_7px_rgba(0,0,0,0.07)]" >
                    <img src={logo1} alt="HWORK2 Logo" style={{ width: 215, height: 41 }} />
                </div>
                <div className="mt-6 w-full overflow-x-hidden flex items-center justify-center ">


                    {/* Main Login Card */}
                    <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
                        {/* Card Header */}
                        <div className="text-center mb-8">
                            <div className=" flex items-center justify-center mx-auto mb-4 relative" style={{ width: 123 }}>
                                <img src={logo} alt="HWORK2 Logo" className="w-full h-full" />


                            </div>
                            <h1 className="font-semibold text-[24px] leading-[32px] text-center text-[#151417] mb-2" style={{ fontFamily: 'Lato, sans-serif' }}>The HWORK2 Method</h1>
                            {/* <p className="text-purple-600 italic"style={{fontFamily: 'Playfair Display, serif', fontSize:32}}>Unlock Your Potential</p> */}
                            <img src={textlogo} alt="HWORK2 Logo" className="w-full h-full" />
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
                            <div>
                                <label className="block font-semibold mb-1 text-gray-800 text-sm sm:text-base">Email Address</label>
                                <input
                                    type="email"
                                    placeholder="name@mail.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    disabled={isLoading}
                                    className="w-full border-2 border border-gray-300 rounded-lg px-2 py-2 focus-within:border-purple-500 transition"
                                />
                                <p className="text-xs text-gray-500 mt-1">
                                    Enter the email address you used during registration
                                </p>
                            </div>
                            <button
                                type="submit"
                                disabled={isLoading}
                                className="w-full py-2 sm:py-3 rounded bg-[#7A81FF] text-white font-bold shadow-md text-sm sm:text-base lg:text-lg mt-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {isLoading ? 'Sending OTP...' : 'Send OTP'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

        </>
    );
};

export default ForgotPassword; 